module.exports = __webpack_public_path__ + "static/media/salesforce.518fa05c.svg";